import React, { useCallback, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, IconButton } from '@mui/material';

import EmailLink from 'pages/Landings/components/EmailLink';
import ContactSalesForm from 'pages/Landings/sections/Company/Contacts/components/Sales/components/ContactSalesForm';

import useStyles from './styles';

interface Props {
    isOpen?: boolean;
    onClose?: () => void;
    className?: string;
}

enum View {
    FORM = 'form',
    SUCCESS = 'success',
    FAILURE = 'failure'
}

const ContactSalesDialog: React.FC<Props> = ({ isOpen, onClose, className }) => {
    const { classes } = useStyles();
    const [view, setView] = useState(View.FORM);

    const onSuccess = useCallback(() => setView(View.SUCCESS), []);
    const onFailure = useCallback(() => setView(View.FAILURE), []);

    return (
        <Dialog
            open={!!isOpen}
            TransitionProps={{
                unmountOnExit: true,
                mountOnEnter: true,
                onEnter: () => setView(View.FORM)
            }}
            keepMounted={false}
            closeAfterTransition
            onClose={onClose}
            className={className}
        >
            <IconButton onClick={onClose} className={classes.close}>
                <CloseIcon />
            </IconButton>
            <DialogContent className={classes.content}>
                {view === View.FORM ? <ContactSalesForm onSuccess={onSuccess} onFailure={onFailure} /> : null}
                {view === View.SUCCESS ? (
                    <p className={classes.message}>
                        <span className={classes.title}>{'Our team will contact you as soon as possible!'}</span>
                        <span className={classes.icon}>🤝</span>
                    </p>
                ) : null}
                {view === View.FAILURE ? (
                    <p className={classes.message}>
                        <span className={classes.title}>{'Something went wrong!'}</span>
                        <span className={classes.description}>
                            {'Please, try again later or send an email to'}
                            &nbsp;
                            <EmailLink email="sales@vulners.com" />
                        </span>
                    </p>
                ) : null}
            </DialogContent>
        </Dialog>
    );
};

export default ContactSalesDialog;
